import React, { Component } from 'react';
import kebabCase from 'lodash/kebabCase';
import PropTypes from 'prop-types';
import _isEqual from 'lodash/isEqual';

import DropdownItem from 'components/DropdownItem';
import RadioButton from 'components/RadioButton';
import './style.scss';

export default class FilterMenuItemRadio extends Component {
  static propTypes = {
    handleClick: PropTypes.func,
    name: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.object),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  };

  shouldComponentUpdate({ value }) {
    return !_isEqual(value, this.props.value);
  }

  render() {
    const { name, options, value, handleClick } = this.props;

    return (
      <React.Fragment>
        {options.map(item => (
          <DropdownItem
            key={item.label}
            data-test={`radiobutton-${kebabCase(item.label)}`}
            isDisabled={item.disabled}
          >
            <RadioButton
              handleClick={handleClick}
              isActive={item.value === value}
              item={item}
              name={name}
              styleName="radio"
            >
              {item.label}
            </RadioButton>
          </DropdownItem>
        ))}
      </React.Fragment>
    );
  }
}
